// Define individual model objects
const EPT1_5 = {
  id: 'ept1_5',
  label: 'EPT-1.5',
  description: 'Earth Physics Transformer – global AI weather forecast model from Jua',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: '1. Jan 2023 - 31. Dec 2023',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
};

const EPT1_5_EARLY = {
  id: 'ept1_5_early',
  label: 'EPT-1.5 Early',
  description: 'Early release of EPT-1.5 with faster updates',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: '18. March 2023 - 31. July 2023',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
};

const EPT2 = {
  id: 'ept2',
  label: 'EPT-2',
  description: 'Earth Physics Transformer – global AI weather forecast model from Jua',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: '1. Jan 2023 - 31. Dec 2023',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
};

const EPT2_REASONING = {
  id: 'ept2_reasoning',
  label: 'EPT-2 Reasoning',
  description: 'Global AI weather forecast model with active learning from live data',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
  banner: 'RESEARCH PREVIEW',
};

const EPT2_EARLY = {
  id: 'ept2_early',
  label: 'EPT-2 Early',
  description: 'Early release of EPT-2 with faster updates',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: '1. Jan 2023 - 31. Dec 2023',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
};

const EPT2_E = {
  id: 'ept2_e',
  label: 'EPT-2e',
  description:
    'Earth Physics Transformer Ensemble - 30 member global AI ensemble weather forecast model from Jua',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'jua',
  benchmarkPeriod: '1. Jan 2023 - 31. Dec 2023',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
  ensembleStats: ['mean', 'q5', 'q25', 'q75', 'q95'],
};

const EPT2_RR = {
  id: 'ept2_rr',
  label: 'EPT-2 RR',
  description: 'Rapid refresh forecast model from Jua with 24 updates per day',
  resolution: '0.25° (~25km)',
  updateFrequency: '1 hour',
  provider: 'jua',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
  ensembleStats: [],
  banner: 'RESEARCH PREVIEW',
};

const EPT2_HRRR = {
  id: 'ept2_hrrr',
  label: 'EPT-2 HRRR',
  description: 'High-resolution rapid refresh forecast model from Jua with 24 updates per day',
  resolution: '0.05° (~5km)',
  updateFrequency: '1 hour',
  provider: 'jua',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['population', 'wind_capacity', 'solar_capacity'],
  ensembleStats: ['mean', 'q5', 'q25', 'q75', 'q95'],
  banner: 'RESEARCH PREVIEW',
};

const AURORA = {
  id: 'aurora',
  label: 'Microsoft Aurora',
  description: 'Deterministic high-resolution global AI weather forecast model from Microsoft',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: '1. Jan 2023 - 31. Dec 2024',
  supportedAggregations: ['population'], // Only has 10m wind, no SSRD
};

const AIFS = {
  id: 'aifs',
  label: 'EC AIFS',
  description: 'Deterministic global AI weather forecast model from ECMWF',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: '2. Jan 2023 - 28. Dec 2024',
  supportedAggregations: ['population', 'wind_capacity'],
};

const GFS_GRAPHCAST025 = {
  id: 'gfs_graphcast025',
  label: 'GFS Graphcast',
  description: 'Google Graphcast weather forecast model initialised by NOAA',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [], // only has 10m wind, no SSRD
};

const ECMWF_IFS_SINGLE = {
  id: 'ecmwf_ifs_single',
  label: 'EC IFS',
  description: 'Deterministic global weather forecast model from ECMWF',
  resolution: '0.081° (~9km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['wind_capacity', 'solar_capacity', 'population'],
};

const ECMWF_IFS025_ENSEMBLE = {
  id: 'ecmwf_ifs025_ensemble',
  label: 'EC Ensemble Mean',
  description:
    'Ensemble of deterministic high-resolution global weather forecast models from ECMWF',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const ECMWF_AIFS025_ENSEMBLE = {
  id: 'ecmwf_aifs025_ensemble',
  label: 'ECMWF AIFS Ensemble',
  description: 'Ensemble of AIFS models from ECMWF',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
  ensembleStats: ['mean', 'q5', 'q25', 'q75', 'q95'],
};

const NOAA_GFS_SINGLE = {
  id: 'noaa_gfs_single',
  label: 'NOAA GFS',
  description: 'Global Forecast System from NOAA',
  resolution: '0.25° (~25km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['wind_capacity', 'solar_capacity', 'population'],
};

const GFS_GLOBAL_ENSEMBLE = {
  id: 'gfs_global_ensemble',
  label: 'GFS Ensemble Mean',
  description: 'Ensemble of global weather forecast models from NOAA',
  resolution: '0.11° (~13km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const METEOFRANCE_AROME_FRANCE_HD = {
  id: 'meteofrance_arome_france_hd',
  label: 'AROME France HD',
  description: 'High-resolution Météo-France AROME weather forecast',
  resolution: '0.01° (~1.5km)',
  updateFrequency: '1 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const ICON_EU = {
  id: 'icon_eu',
  label: 'ICON-EU',
  description: 'High-resolution European weather forecast model from DWD',
  resolution: '0.0625° (~7km)',
  updateFrequency: '3 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const ICON_GLOBAL = {
  id: 'icon_global',
  label: 'ICON Global',
  description: 'Global weather forecast model from DWD',
  resolution: '0.125° (~13km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: ['population', 'solar_capacity'], // Only has 10m wind
};

const ICON_D2 = {
  id: 'icon_d2',
  label: 'ICON-D2',
  description: 'High-resolution regional forecast from DWD (Central Europe)',
  resolution: '0.02° (~2km)',
  updateFrequency: '1 hour',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const KNMI_HARMONIE_AROME_EUROPE = {
  id: 'knmi_harmonie_arome_europe',
  label: 'KNMI HARMONIE-AROME Europe',
  description: 'High-resolution regional forecast from KNMI covering Europe',
  resolution: '0.05° (~5.5km)',
  updateFrequency: '1 hour',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const KNMI_HARMONIE_AROME_NETHERLANDS = {
  id: 'knmi_harmonie_arome_netherlands',
  label: 'KNMI HARMONIE-AROME Netherlands',
  description: 'High-resolution regional forecast from KNMI covering the Netherlands',
  resolution: '0.025° (~2.8km)',
  updateFrequency: '1 hour',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const UKMO_GLOBAL_DETERMINISTIC_10KM = {
  id: 'ukmo_global_deterministic_10km',
  label: 'UKMO Global (10km)',
  description: 'UK Met Office global deterministic forecast',
  resolution: '0.083° (~10km)',
  updateFrequency: '6 hours',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

const UKMO_UK_DETERMINISTIC_2KM = {
  id: 'ukmo_uk_deterministic_2km',
  label: 'UKMO UKV (2km)',
  description: 'UK Met Office high-resolution UK deterministic forecast',
  resolution: '0.018° (~2km)',
  updateFrequency: '1 hour',
  provider: 'external',
  benchmarkPeriod: 'not benchmarked',
  supportedAggregations: [],
};

// Create arrays of models
export const FORECAST_MODELS = [
  EPT1_5,
  EPT1_5_EARLY,
  EPT2,
  EPT2_EARLY,
  EPT2_REASONING,
  ECMWF_IFS_SINGLE,
  ECMWF_IFS025_ENSEMBLE,
  NOAA_GFS_SINGLE,
  ECMWF_AIFS025_ENSEMBLE,
  GFS_GLOBAL_ENSEMBLE,
  METEOFRANCE_AROME_FRANCE_HD,
  ICON_EU,
  ICON_GLOBAL,
  ICON_D2,
  KNMI_HARMONIE_AROME_EUROPE,
  KNMI_HARMONIE_AROME_NETHERLANDS,
  UKMO_GLOBAL_DETERMINISTIC_10KM,
  UKMO_UK_DETERMINISTIC_2KM,
  GFS_GRAPHCAST025,
  EPT2_E,
  EPT2_RR,
  EPT2_HRRR,
  AURORA,
  AIFS,
] as const;

// Live benchmarking models subset
export const LIVE_BENCHMARKING_MODELS = [EPT1_5, EPT1_5_EARLY] as const;

export type BaseForecastModel = (typeof FORECAST_MODELS)[number];
export type BaseLiveBenchmarkingModel = (typeof LIVE_BENCHMARKING_MODELS)[number];

// Add banner to the base model type
export type BaseModel = {
  id: string;
  label: string;
  description: string;
  resolution: string;
  updateFrequency: string;
  provider: string;
  benchmarkPeriod: string;
  supportedAggregations: string[];
  banner?: string;
};

export type BaseForecastModelWithAvailability = BaseModel & { available?: boolean };
export type BaseLiveBenchmarkingModelWithAvailability = BaseModel & { available?: boolean };

export type ForecastModel = BaseForecastModel['id'];
export type LiveBenchmarkingModel = BaseLiveBenchmarkingModel['id'];

// TODO: Make model filtering by permissions and features a reusable function
export const getJuaModels = () => FORECAST_MODELS.filter((model) => model.provider === 'jua');

export const JUA_MODELS = getJuaModels();

export const getModelsForAggregation = (aggregation: string) =>
  FORECAST_MODELS.filter((model) => model.supportedAggregations.includes(aggregation as never));
